import Vue from 'vue';
import StorageService from './storage.service';

export class LoginService {
  loginUrl;

  trackingApiRoot;

  session;

  constructor(loginUrl) {
    this.loginUrl = loginUrl;
    this.trackingApiRoot = `${this.loginUrl}/v1/login/users/lead-tracking-permissions`;
    const sessionDTO = JSON.parse(StorageService.getItem('authSession') || 'null');
    if (sessionDTO && sessionDTO.session) {
      this.session = sessionDTO.session;
    }
  }

  async setTrackingEnabled(fairEventUid, enabled) {
    if (this.session) {
      if (this.hasTrackingConfiguredFor(fairEventUid)) {
        let permission = this.getPermission(fairEventUid);
        const updated = await this.updateLeadTrackingPermission(permission.id, {active: enabled});
        const user = this.getLmsUser();
        permission = this.getPermission(fairEventUid);
        const permissionForUpdate = user.permissions.find(p => p.id === permission.id);
        permissionForUpdate.updatedAt = updated.updatedAt;
        permissionForUpdate.active = updated.active;
        StorageService.setItem('buyerData', JSON.stringify(user));
      } else {
        const created = await this.createLeadTrackingPermission({active: enabled, fairEvent: fairEventUid});
        const user = this.getLmsUser();
        user.permissions.push(created);
        StorageService.setItem('buyerData', JSON.stringify(user));
      }
    }
  }

  async createLeadTrackingPermission(payload) {
    const response = await Vue.prototype.axios({
      method: 'post',
      url: this.trackingApiRoot,
      headers: this.getHeaderData(),
      data: payload,
    });
    return response.data || null;
  }

  async updateLeadTrackingPermission(id, payload) {
    const response = await Vue.prototype.axios({
      method: 'put',
      url: `${this.trackingApiRoot}/${id}`,
      headers: this.getHeaderData(),
      data: payload,
    });
    return response.data || null;
  }

  /**
   * Whether the user has agreed to tracking his activity on the xposphere part of the website
   * @returns {boolean}
   */
  isTrackingAllowed(fairEventUid) {
    const lmsUser = this.getLmsUser();
    if (lmsUser && lmsUser.accountCode && this.hasTrackingConfiguredFor(fairEventUid)) {
      return this.allowsTracking();
    }
    return false;
  }

  /**
   * On false: First time visit. Never said no or yes to this fair event.
   * @returns {boolean}
   */
  hasTrackingConfiguredFor(fairEventUid) {
    const lmsUser = this.getLmsUser();
    if (lmsUser && lmsUser.accountCode) {
      return this.getPermission(fairEventUid) !== null;
    }
    return false;
  }

  allowsTracking(fairEventUid) {
    return this.getLmsUser().permissions.find(p => p.fairEvent.id === fairEventUid && p.active) !== undefined;
  }

  getPermission(fairEventUid) {
    return this.getLmsUser().permissions.find(p => p.fairEvent.id === fairEventUid) || null;
  }

  getLmsUser() {
    if (this.lmsUser) {
      return this.lmsUser;
    }
    const lmsUserData = StorageService.getItem('buyerData');
    if (lmsUserData) {
      this.lmsUser = JSON.parse(lmsUserData);
      return this.lmsUser;
    }
    return null;
  }

  getHeaderData() {
    return {
      'content-type': 'application/json; charset=utf-8',
      authorization: `Bearer ${this.session}`,
    };
  }
}
